import { IonIcon, IonRow, IonLabel } from '@ionic/react';
import { clearLoads, fetchResults } from '../../../actions/Search/action';
import { storeSearchParamVault } from '../../../pages/Search/New/NewPage.util';
import { isMobile } from '../../../utils/common';
import { DryVan, Navigate_Module, RELOAD_OFFSET, TAB_HEADERS_WEB } from '../../../utils/constants';
import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import "./ReloadButton.scss";
import { constructSearchData, constructSearchParams, constructSimilarRouterSearchData, constructSimilarRouteSearchParams, getEventDetails } from './RelodButton.util';
import { useHistory } from 'react-router';
import { logEvent } from '../../../utils/Analytics';
import { getOffSet } from 'app/selectors/Search/selector';


const ReloadButton = (props: any) => {
    const offSetValue = useSelector(getOffSet()) || RELOAD_OFFSET;
    const dispatch = useDispatch();
    const { push, location } = useHistory();
    const { location: { pathname } } = useHistory();
    const { userDetails, stopDetails, transportMode = DryVan, isRecentlyDelivered = false, isRecommended = false, isExpandedCard, onRedirectToTab = () => { }, id, recommended=false } = props;
    const isMobileRoutes = isMobile ? "Similar Routes ...": "Similar Routes Available";
    const similarRoutes = ((isExpandedCard === null || !isExpandedCard)) ? "Similar Routes Available" : isMobileRoutes;
    const buttonName = useMemo(()=> (isRecentlyDelivered) ? similarRoutes : "Reload",[isRecentlyDelivered,isExpandedCard]);
    const isRecommendedButton = (isRecommended) ? "reload-button reload-button-recommended" : "reload-button";

    const onNextPickupLoadAvailable = async (e: any) => {
        e?.preventDefault();
        e?.stopPropagation();
        const stopDetailsObj = stopDetails && stopDetails.find((stop: any) => stop.stopType === "D");
        const searchParams = isRecentlyDelivered ? constructSimilarRouteSearchParams(stopDetails, offSetValue, transportMode) : constructSearchParams(stopDetailsObj, offSetValue, transportMode);
        const searchData = isRecentlyDelivered ? constructSimilarRouterSearchData(stopDetails, userDetails, offSetValue, transportMode) : constructSearchData(stopDetailsObj, userDetails, offSetValue, transportMode);
        dispatch(clearLoads());
        dispatch(fetchResults(searchData, false, false, () => { 
            if(!isMobile){
                setTimeout(()=>{
                    document?.getElementsByClassName("sni-body-container")[0]?.scrollTo(0,750);
                },250)
            }
        }));
        if (isMobile) {
            await storeSearchParamVault(searchParams);
            push(Navigate_Module.search_results, {
                params: searchParams,
                searchInput: searchParams,
                totalRecords: 0,
                isRecent: false,
                isReloadButton: true,
                pathname: "",
                newSearch: true,
                isSimilarRoute:true
            })
        }
        else {
            location.pathname.includes("search") && onRedirectToTab && onRedirectToTab(TAB_HEADERS_WEB.NEW_SEARCH);
            push(Navigate_Module.search, {
                params: searchParams,
                searchInput: searchParams,
                totalRecords: 0,
                isRecent: false,
                isReloadButton: true,
                isRecommendedFlow: false,
                isSimilarRoute:isRecentlyDelivered
            });
        }
        const shipmentId = id || "";
        const carrierId = (userDetails?.memberDetailsResponse?.member?.carrierId) || "";
        const roles =  (userDetails?.memberDetailsResponse?.member?.userApplicationDetails[0]?.roles) || [];
        logEvent(getEventDetails(pathname,recommended).eventName, {
            screen:getEventDetails(pathname,recommended).screenName,
            carrierId,
            shipmentId,
            roles
        });
    }
    return (
        <IonRow data-test="Reload-Button" className={isMobile ? "reload-button-mobile" : isRecommendedButton} onClick={onNextPickupLoadAvailable}>
            {isRecentlyDelivered ? 
            <IonIcon className={"reload-icon"} src="assets/icon/similar_routes.svg"/> :
            <IonIcon className={"reload-icon"} src="assets/icon/reload_icon.svg"/>
            }
            <IonLabel className={"reload-label"}>{buttonName}</IonLabel>
        </IonRow>
    );
}


export { ReloadButton }